import { z } from 'zod';

// Overprinting Form Schema
export const overprintingFormSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  email: z.string().email('Valid email address is required'),
  phone: z.string().min(1, 'Phone number is required'),
  schoolName: z.string().min(1, 'School name is required'),
  notes: z.string().min(1, 'Notes are required'),
});

export const overprintingFormWithFileSchema = overprintingFormSchema.extend({
  overprintingFile: z
    .instanceof(File, { message: 'File is required' })
    .refine(
      (file) => {
        return file.size <= 10 * 1024 * 1024; // 10MB limit
      },
      { message: 'File size must be less than 10MB' },
    )
    .refine(
      (file) => {
        const allowedTypes = [
          'application/pdf',
          'image/jpeg',
          'image/jpg',
          'image/png',
          'image/tiff',
          'image/tif',
        ];
        return allowedTypes.includes(file.type);
      },
      { message: 'Only PDF, JPG, PNG, and TIFF files are allowed' },
    ),
});

export type OverprintingFormSchema = z.infer<typeof overprintingFormSchema>;
export type OverprintingFormWithFileSchema = z.infer<
  typeof overprintingFormWithFileSchema
>;
